import { StyleSheet, ViewStyle } from "react-native";
import React from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import ThemedView from "../core/ThemedView";

interface BodyViewProps {
  children: React.ReactNode;
  style?: ViewStyle;
  horizontalPadding?: number;
}

const BodyView = ({
  children,
  style = {},
  horizontalPadding = 16,
}: BodyViewProps) => {
  const insets = useSafeAreaInsets();

  const {
    paddingTop,
    paddingLeft,
    paddingRight,
    paddingHorizontal,
    ...restStyle
  } = style;

  return (
    <ThemedView
      style={[
        styles.container,
        {
          paddingTop: paddingTop !== undefined ? paddingTop : insets.top,
          paddingLeft:
            paddingLeft !== undefined
              ? paddingLeft
              : insets.left + horizontalPadding,
          paddingRight:
            paddingRight !== undefined
              ? paddingRight
              : insets.right + horizontalPadding,
        },
        restStyle,
      ]}
    >
      {children}
    </ThemedView>
  );
};

export default BodyView;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
